<template>
  <div class="flex flex-col items-center justify-center">
    <h3 class="text-primary text-center">{{ $t("wizard.book_table") }}</h3>
    <p class="text-primary text-center underline">{{ $t("wizard.address") }}</p>
    <people></people>
    <select-date></select-date>
    <select-hour></select-hour>
    <div class="next-container">
      <router-link class="btn btn-outline-primary mb-6" :class="{disabled: !validButton}" v-ripple :to="{name: 'personal-data'}">{{ $t('wizard.next') }}</router-link>
      <span>{{$t('wizard.call_us_1')}} <a href="tel:+34933233953" class="text-primary underline">933 233 953</a> {{$t('wizard.call_us_2')}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import People from "./components/People.vue";
import SelectDate from "./components/SelectDate.vue";
import SelectHour from "./components/SelectHour.vue";

export default {
  components: {
    People,
    SelectDate,
    SelectHour
  },
  computed: {
    ...mapGetters({
      validButton: "getValidButton"
    })
  }
};
</script>

<style lang="scss" scoped>
.next-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}
</style>